<script setup>
const capitalize = (str) =>
  str ? str.charAt(0).toUpperCase() + str.slice(1) : '';

defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
  view: {
    type: String,
    default: 'light',
    validator(value) {
      return ['dark', 'light'].includes(value);
    },
  },
});
</script>
<template>
  <ul v-if="data" class="m-0 p-0 socials">
    <template
      v-for="(socialItem, socialItemIndex) in data"
      :key="socialItemIndex"
    >
      <li v-if="socialItem.url" class="m-0 socials__item">
        <Button
          v-slot="slotProps"
          as-child
          rounded
          variant="outlined"
          size="large"
        >
          <CTagDetect
            :to="socialItem.url"
            :class="[
              slotProps.class,
              `button-icon-only--${view}`,
              `js-button-socials-${socialItem.icon}`,
            ]"
            class="socials__item-button button-icon-only"
            :aria-label="capitalize(socialItem.icon)"
          >
            <CIcon
              class="socials-item-icon button-icon-only__icon"
              :name="`icon-${socialItem.icon}`"
              width="24"
              height="24"
            />
          </CTagDetect>
        </Button>
      </li>
    </template>
  </ul>
</template>

<style scoped lang="scss">
.socials {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 16px;
  list-style: none;
  @include media-breakpoint-up(xl) {
    @include responsive-spacing(gap, 16);
  }
}
</style>
